function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFamily = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.149,
    y: 1.899,
    width: 44,
    height: 44,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.139,23.867C40.139,24.992 39.202,25.874 38.139,25.874L36.139,25.874L36.183,35.887C36.183,36.056 36.17,36.225 36.152,36.393L36.152,37.4C36.152,38.781 35.033,39.9 33.651,39.9L32.651,39.9C32.583,39.9 32.514,39.9 32.445,39.894C32.357,39.9 32.27,39.9 32.182,39.9L28.651,39.9C27.27,39.9 26.151,38.781 26.151,37.4L26.151,31.899C26.151,30.793 25.257,29.899 24.151,29.899L20.15,29.899C19.044,29.899 18.15,30.793 18.15,31.899L18.15,37.4C18.15,38.781 17.031,39.9 15.65,39.9L12.156,39.9C12.062,39.9 11.968,39.894 11.875,39.887C11.799,39.894 11.724,39.9 11.649,39.9L10.649,39.9C9.268,39.9 8.149,38.781 8.149,37.4L8.149,30.399C8.149,30.343 8.149,30.28 8.155,30.224L8.155,25.874L6.149,25.874C5.024,25.874 4.149,24.999 4.149,23.867C4.149,23.305 4.336,22.805 4.774,22.367L20.8,8.397C21.238,7.96 21.738,7.897 22.175,7.897C22.613,7.897 23.113,8.022 23.488,8.335L39.452,22.367C39.952,22.805 40.202,23.305 40.139,23.867Z",
    style: {
      fill: "#00659d",
      fillRule: "nonzero"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFamily);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/family.89234a6f9d541132e9db6a304e52308b.svg";